import ownerWindow from './ownerWindow';
/**
 * Returns one or all computed style properties of an element.
 * 
 * @param node the element
 * @param psuedoElement the style property
 */

export default function getComputedStyle(node, psuedoElement) {
  return ownerWindow(node).getComputedStyle(node, psuedoElement);
}


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/esm/getComputedStyle.js
// module id = 1196
// module chunks = 0